import { jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function ContentComponent({ children, typographyProps = {}, sx = {}, }) {
    if (!children) {
        return null;
    }
    return typeof children === "string" ? (jsx(Typography, Object.assign({ sx: Object.assign({ alignSelf: "stretch" }, sx), variant: "small" }, typographyProps, { children: children }))) : (jsx(ContentWrapper, { sx: sx, children: children }));
}
const ContentWrapper = styled("div")({
    display: "inline-flex",
    flexDirection: "column",
    alignSelf: "stretch",
});

export { ContentComponent };
//# sourceMappingURL=ContentComponent.js.map
